import React  from 'react';
import PropTypes from 'prop-types';

const SocialNetworksItem = (props) => {
    return (
            <a href={props.link} target="_blanck" rel="noreferrer">
                <img src={`api/welsend/public/socialNetworks/${props.id}/file`} referrerPolicy="no-referrer"/>
            </a>
    )
    
}

export default SocialNetworksItem;

SocialNetworksItem.propTypes = {
    id: PropTypes.number.isRequired,
    link: PropTypes.string.isRequired,
}